import PubSub from "underpub-js";

var ListingUnitsFilters = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-ListingUnitsFilters',
	};

	$.extend(true, this.options, options);
	
};

ListingUnitsFilters.prototype.init = function() {

	var self = this;
	self.initSelectDropdowns();
};
ListingUnitsFilters.prototype.initSelectDropdowns = function(){
	
	const self = this;
	

    self.options.$el.find('select').on('change', function() {
	
        $(this).removeClass('value-selected');

        if ($(this).val() != '')
        {
            $(this).addClass('value-selected');
        }

    });

};
export default ListingUnitsFilters;
